export enum GameState {
    MainMenu,
    Standby,
    Running,
    Paused,
    GameOver
}